import { ContentCopy } from '@mui/icons-material'
import styled from 'styled-components'
import { COLORS } from 'utils'

import { IconStyles } from '../types'

export const ContentCopyCustom = styled(ContentCopy)<IconStyles>`
  margin-top: ${({ marginTop }) => marginTop || '0'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  margin-left: ${({ marginLeft }) => marginLeft || '0'};
  margin-right: ${({ marginRight }) => marginRight || '0'};
  height: ${({ height }) => height || '20px'};
  width: ${({ width }) => width || '20px'};
  cursor: pointer;
  color: ${COLORS.darkGray};
`
